/**
 * Auth Bridge -- Module-level ref for imperative token access (D-13).
 * Set by the useAuth adapter when AuthProvider mounts.
 * Consumed by apiUtils.ts for Bearer token acquisition outside React components.
 */

let getAccessTokenFn: (() => Promise<string>) | null = null
const waiters = new Set<() => void>()

function waitForBridge(timeoutMs = 5000): Promise<void> {
	if (getAccessTokenFn) return Promise.resolve()

	return new Promise((resolve, reject) => {
		const timeout = window.setTimeout(() => {
			waiters.delete(done)
			reject(new Error("Auth bridge not initialized"))
		}, timeoutMs)

		function done() {
			window.clearTimeout(timeout)
			waiters.delete(done)
			resolve()
		}

		waiters.add(done)
	})
}

export function setAuthBridge(fn: (() => Promise<string>) | null): void {
	getAccessTokenFn = fn
	if (fn) {
		for (const waiter of waiters) waiter()
	}
}

export async function getAccessToken(): Promise<string> {
	if (!getAccessTokenFn) await waitForBridge()
	if (!getAccessTokenFn) throw new Error("Auth bridge not initialized")
	return getAccessTokenFn()
}
